const menu = [
  {
    title: '首页',
    url: '/'
  },
  {
    title: '通知公告',
    url: '/notice/list',
    subMenuShow: false,
    children: [
      {
        title: '通知公告详情',
        url: '/notice/detail/:id'
      }
    ]
  },
  {
    title: '保单录入',
    url: '',
    children: [
      {
        title: '报价',
        url: '/product/quote'
      },
      {
        title: '报价',
        url: '/product/quote/:frmNo/:vehicleId/:vehicleOwnerId'
      },
      {
        title: '新保',
        url: '/product/new'
      },
      {
        title: '续保',
        url: '/product/continue/create/new'
      },
      {
        title: '售后续保',
        url: '/product/aftersale'
      },
      {
        url: '/product/elec',
        title: '电销投保'
      },
    ]
  },
  {
    title: '保单管理',
    url: '',
    children: [
      {
        title: '保单查询',
        url: '/vehicle_policy/0',
        children: [
          {
            title: '保单详情',
            url: '/vehicle_policy/:id'
          },
          {
            title: '新建保单保全',
            url: '/policy_modify_create/:id'
          },
          {
            title: '增保',
            url: '/vehicle_policy_add/:id'
          },
          {
            title: '减保',
            url: '/vehicle_policy_reduce/:id'
          }
        ]
      },
      {
        title: '手工录单',
        url: '/vehicle_policy_draft',
        children: [
          {
            title: '新建手工录单',
            url: '/vehicle_policy_entry'
          },
          {
            title: '编辑手工录单',
            url: '/vehicle_policy_entry/:draftId'
          }
        ]
      },
      {
        title: '理赔管理',
        url: '/claim/management'
      },
      {
        title: '询价单',
        url: '/inquiry_sheet',
        children: [
          {
            title: '详情',
            url: '/inquiry_sheet/detail/:vehicleEnquiryId'
          }
        ]
      },
      {
        title: '保单列表',
        url: '/vehicle_policy_service',
        children: [
          {
            title: '保单详情',
            url: '/vehicle_policy_service/:id'
          }
        ]
      },
      {
        title: '出单信息采集',
        url: '/policy_info_collection',
        children: [
          {
            title: '出单信息采集详情',
            url: '/policy_info_collection/detail/:id'
          }
        ]
      },
      {
        title: '全部手工录单',
        url: '/policy_draft_all',
        children: [
          {
            title: '新建手工录单',
            url: '/vehicle_policy_entry_all'
          },
          {
            title: '编辑手工录单',
            url: '/vehicle_policy_entry_all/:draftId'
          }
        ]
      },
      {
        title: '非车险保单',
        url: '/general_policy',
        children: [
          {
            title: '非车险保单详情',
            url: '/general_policy/detail/:id'
          },
          {
            title: '非车险保单增保',
            url: '/general_policy/add/:nonVehPolicyId'
          },
          {
            title: '非车险保单减保',
            url: '/general_policy/reduce/:nonVehPolicyId'
          },
          {
            title: '非车险保单保全',
            url: '/general_policy/modify/:nonVehPolicyId'
          }
        ]
      },
      {
        title: '非车险保单草稿',
        url: '/general_policy_draft',
        children: [
          {
            title: '新建非车险保单草稿',
            url: '/general_policy_entry'
          },
          {
            title: '编辑非车险保单草稿',
            url: '/general_policy_entry/:draftId'
          }
        ]
      }
    ]
  },
  {
    title: '保单保全',
    url: '',
    children: [
      {
        title: '车险保单保全',
        url: '/policy_modify',
        children: [
          {
            title: '车险保单保全审核',
            url: '/policy_modify/:id'
          }
        ]
      },
      {
        title: '非车险保单保全',
        url: '/general_policy_modify',
        children: [
          {
            title: '非车险保单保全审核',
            url: '/general_policy_modify/:id'
          }
        ]
      }
    ]
  },
  {
    title: '客户管理',
    url: '',
    children: [
      {
        title: '客户查询',
        url: '/customer',
        children: [
          {
            title: '新建客户',
            url: '/customer/add'
          },
          {
            title: '客户详情',
            url: '/customer/detail/:id'
          }
        ]
      },
      {
        title: '回访记录',
        url: '/customer_visit'
      },
      {
        title: '投诉处理',
        url: '/customer_complain'
      },
      {
        title: '客户关怀',
        url: '/customer_care',
        children: [
          {
            title: '发送用户',
            url: '/customer_care/send_user/:customerCareId'
          }
        ]
      },
      {
        title: '上门服务',
        url: '/customer_delivery'
      },
      {
        title: '进场记录',
        url: '/entry/record',
        children: [
          {
            title: '进场记录详情',
            url: '/entry/record/detail/:id',
            children: [
              {
                title: '跟踪记录',
                url: '/entry/record/detail/:id/track/:customerId/:vehicleId'
              }
            ]
          }
        ]
      },
      {
        title: '礼物管理',
        url: '/customer_gift'
      },
      {
        title: '礼物配送',
        url: '/gift_delivery'
      },
      {
        title: '客户列表',
        url: '/customer_service',
        children: [
          {
            title: '客户详情',
            url: '/customer_service/detail/:id'
          }
        ]
      }
    ]
  },
  {
    title: '流失客户管理',
    url: '',
    children: [
      {
        title: '未分配流失客户',
        url: '/lose/not/allotted',
        children: [
          {
            title: '客户详情',
            url: '/lose/not/allotted/detail/:vehicleId/:customerId',
            children: [
              {
                url: '/lose/not/allotted/detail/:vehicleId/:customerId/insure-detail/:id',
                title: '保单详情'
              },
              {
                url: '/lose/not/allotted/detail/:vehicleId/:customerId/insure',
                title: '电销投保'
              }
            ]
          }
        ]
      },
      {
        title: '已分配流失客户',
        url: '/lose/allotted',
        children: [
          {
            title: '客户详情',
            url: '/lose/allotted/detail/:vehicleId/:customerId',
            children: [
              {
                url: '/lose/allotted/detail/:vehicleId/:customerId/insure-detail/:id',
                title: '保单详情'
              },
              {
                url: '/lose/allotted/detail/:vehicleId/:customerId/insure',
                title: '电销投保'
              }
            ]
          }
        ]
      },
      {
        title: '已分配给我的客户',
        url: '/lose/allotted/self',
        children: [
          {
            title: '客户详情',
            url: '/lose/allotted/self/detail/:vehicleId/:customerId',
            children: [
              {
                url: '/lose/allotted/self/detail/:vehicleId/:customerId/insure-detail/:id',
                title: '保单详情'
              },
              {
                url: '/lose/allotted/self/detail/:vehicleId/:customerId/insure',
                title: '电销投保'
              }
            ]
          }
        ]
      }
    ]
  },
  {
    title: '单证管理',
    url: '',
    children: [
      {
        title: '单证入库',
        url: '/documents_storage'
      },
      {
        title: '单证发放',
        url: '/documents_dispatch',
        children: [
          {
            title: '单证发放操作',
            url: '/documents_dispatch/operation'
          }
        ]
      },
      {
        title: '单证回交/回收',
        url: '/documents_recycling'
      }
    ]
  },
  {
    title: '续保',
    url: '',
    children: [
      {
        title: '待办',
        url: '/product/continue/list/workbench',
      },
      {
        title: '全部续保客户',
        url: '/product/continue/list',
      },
      {
        title: '待续保分析',
        url: '/stat/renewal/customer'
      },
      {
        title: '人员效能',
        url: '/statistics'
      },
      {
        title: '续保录入',
        url: '/product/continue/follow/:vehicleId/:vehicleOwnerId'
      },
      {
        title: '询价单查询',
        url: '/query/list/:vehicleId'
      },
      {
        title: '回访跟踪',
        url: '/revisit/track'
      },
      {
        url: '/renewal/setting',
        title: '续保分配'
      }
    ]
  },
  {
    title: '待回访提醒',
    url: '/visit/remind',
    subMenuShow: false,
    children: [
      {
        title: '订单详情',
        url: '/visit/continue/list/policy/:id/:vehicleId/:vehicleOwnerId'
      },
      {
        title: '待回访详情',
        url: '/visit/remind/detail/:vehiclePolicyId/:vehicleId'
      }
    ]
  },
  {
    title: '逾期待回访',
    url: '/overdue/remind',
    children: [
      {
        title: '订单详情',
        url: '/overdue/continue/list/policy/:id/:vehicleId/:vehicleOwnerId'
      },
      {
        title: '待回访详情',
        url: '/overdue/remind/detail/:vehiclePolicyId/:vehicleId'
      }
    ]
  },
  {
    title: '待办',
    url: '/todo',
    children: [
      {
        title: '跟踪记录',
        url: '/todo/remind/track/list/:customerId/:vehicleId'
      }
    ]
  }
]

export default menu
